import { z } from "zod";
//#region src/api/orpc/contestV2/schemas.ts
/**
* Shared `/v2/contest-v2` zod schemas. Used both by the `contestV2`
* contract (here in pixai-contract) and by the server-side
* `service/contest/*` modules (re-exported from
* `pixai-server/zodSchema/contestV2.ts` so the existing server imports
* keep working).
*
* `localizedStringSchema` continues to live at
* `pixai-contract/api/orpc/shared/localizedString`.
*/
const contestTypeSchema = z.enum(["official", "community"]);
const voteTypeSchema = z.enum(["user_vote", "creator_pick"]);
const lifecycleStatusSchema = z.enum([
	"draft",
	"pending",
	"published",
	"cancelled"
]);
const rewardStatusSchema = z.enum([
	"pending_selection",
	"pending_distribute",
	"distributed"
]);
const runtimeStatusSchema = z.enum([
	"not_started",
	"running",
	"ended"
]);
const contestRuleTypeSchema = z.enum(["required_model_ids", "required_lora_ids"]);
const contestRuleSchema = z.discriminatedUnion("type", [z.object({
	type: z.literal(contestRuleTypeSchema.enum.required_model_ids),
	model_ids: z.array(z.string())
}), z.object({
	type: z.literal(contestRuleTypeSchema.enum.required_lora_ids),
	lora_ids: z.array(z.string())
})]);
const contestRulesSchema = z.array(contestRuleSchema);
const prizeDistributionItemSchema = z.object({
	rank: z.number().int().positive(),
	count: z.number().int().positive(),
	amount: z.number().int().positive()
});
const prizeDistributionSchema = z.array(prizeDistributionItemSchema);
const submitArtworkSourceSchema = z.enum(["manual", "tack"]);
const listByContestSortSchema = z.enum(["newest", "most_liked"]);
//#endregion
export { contestRuleSchema, contestRuleTypeSchema, contestRulesSchema, contestTypeSchema, lifecycleStatusSchema, listByContestSortSchema, prizeDistributionItemSchema, prizeDistributionSchema, rewardStatusSchema, runtimeStatusSchema, submitArtworkSourceSchema, voteTypeSchema };
